import Services from "../Services/Platform/Services";

export const canCreateSensorGroup = () => Services.userCanEdit();
export const canUsePeakWindowing = () => Services.userCanEdit();
export const canEditSensorGroup = (isReadOnly: boolean) => !isReadOnly && Services.userCanEdit();
export const canDeleteSensorGroup = (isReadOnly: boolean, isEmpty: boolean) =>
    !isReadOnly && isEmpty && Services.userCanEdit();
export const canAddRdc = () => Services.userHasPolicy("ChangeDevices") && Services.userCanEdit();
